<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :vendedores="enableVendedores"
          :areas="enableAreas"
          :redes="enableRedes"
          :classificacoes="enableClassificacao"
          :linha-producao="enableLinhaProducao"
          :url="link"
          :habilitar-filtros-data="enableFiltrosDados"
        />
        <br>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'140'"
                    :texto-information="textoFaturamento"
                    :text="'Faturamento'"
                    :componente-valor="true"
                    :style-object="styleObject"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingVendas1"
                    :width="width"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :code-information="'371'"
                    :texto-information="textoFaturamentoAnteior"
                    :text="'Fatu. do Mês no Ano Anterior'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoAnoAnterior"
                    :padding="dynamicPaddingVendas1"
                    :width="width"
                    :loading="loadingFaturamentoAnoAnterior"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    {{ tituloComparativoFatVolume }}
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('372')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '372' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-vendas-comparativo />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :exibir-informacao="true"
              :text="'Acumulado Comparativo Faturamento'"
              :style-object="styleObject"
              :code-information="'373'"
              :texto-information="textoFaturamentoAcumulado"
              :componente-grafico="true"
              :grafico-id="'myChart9'"
              :dados-grafico="chartBarAcumuladoAnual"
              :titulo-id="'myChart9'"
              :padding="dynamicPaddingVendas1"
              :width="width"
              :loading="loadingFaturamentoAcumuladoAnual"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteFaturamentoAnual"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como está o acumulado do ano até o mês atual?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('141')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '141' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-vendas-meses-do-ano />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Vendas from '../../../../services/vendas4'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  export default {
    name: 'PageComercial',
    emits: ['updateDadosClientesVendas', 'updateDatasVendas', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      DashboardVendasComparativo: () => import('../../graficos/Vendas4/VendasComparativoFaturamentoVolume'),
      DashboardVendasMesesDoAno: () => import('../../graficos/Vendas4/VendasMesesdoAnoFatVolume'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisores: [],
      vendedores: [],
      areas: [],
      redes: [],
      receita: [],
      segmento: [],
      classificacoes: [],
      categoria: [],
      promotor: [],
      linhasProducao: [],
      textoFaturamento: '',
      textoFatAcumulado: '',
      textoPrincipaisClientes: '',
      textoFatGrupoItens: '',
      textoFatEvolucaoVendas: '',
      textoVolumeEvolucaoVendas: '',
      textoFaturamentoAnteior: '',
      textoCompativoFaturamento: '',
      textoFaturamentoAcumulado: '',
      codigo: 0,
      informacoes: [],
      codigoIds: ['140', '141', '142', '143', '144', '145', '315', '316', '371', '372', '373'],
      permissaoVenda: '',
      enableFatPrinCliente: false,
      enableEvolucaoVendas: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedores: true,
      enableAreas: true,
      enableRedes: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      enableClassificacao: true,
      enableLinhaProducao: true,
      enableCategoria: true,
      enablePromotor: true,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      legendaGrafico: [
        { cor: '#ed934f', status: 'Variação Anual de Faturamento' },
        { cor: '#cadaed', status: 'Faturamento Ano Anterior' },
        { cor: '#4780b8', status: 'Faturamento Corrente' },
      ],
      chartBarLinha: {},
      chartBarAcumuladoAnual: {},
      chartBarAcumuladoMensal: {},
      legendaGraficoMensal: [
        { cor: '#cadaed', status: 'Faturamento Ano Anterior' },
        { cor: '#4780b8', status: 'Faturamento Corrente' },
      ],
      dynamicPaddingTitulo: '',
      dynamicPaddingVendas1: '',
      dynamicPaddingVendas2: '',
      dynamicPaddingVendas3: '',
      width: '',
      loadingFaturamento: false,
      loadingFaturamentoAnoAnterior: false,
      loadingFaturamento7MesesAnteriores: false,
      loadingFaturamentoAcumuladoAnual: false,
      tituloFatVolume: 'Faturamento',
      tituloFatVolumeAnterior: 'Fatu. do Mês no Ano Anterior',
      tituloComparativoFatVolume: 'Comparativo Faturamento',
      tituloAcumulado: 'Acumulado Anual',
      tituloAcumuladoMes: 'Como está o acumulado do ano até o mês atual? ',
      enableFiltrosDados: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)

      eventEmit.$on('update-dados-somatorio', this.handleUpdateDadosSomatorio)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      eventEmit.$off('update-dados-somatorio', this.handleUpdateDadosSomatorio)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Vendas')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingTitulo = 'padding-right: 104rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 11rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 44rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 104rem !important'

          this.width = ''
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingTitulo = 'padding-right: 82rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 2rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 65rem !important'

          this.width = ''
        } else if (window.innerWidth > 380 && window.innerWidth < 680) {
          this.dynamicPaddingTitulo = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 9rem !important'

          this.width = '370'
        } else if (window.innerWidth > 680 && window.innerWidth < 1000) {
          this.dynamicPaddingTitulo = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 8rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 25rem !important'

          this.width = ''
        } else {
          this.dynamicPaddingTitulo = 'padding-right: 64rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 1rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 23rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 58rem !important'

          this.width = ''
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacoes, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisores = supervisores
        this.vendedores = vendedores
        this.areas = areas
        this.redes = redes
        this.receita = receita
        this.segmento = segmento
        this.classificacoes = classificacoes
        this.categoria = categoria
        this.promotor = promotor
        this.linhaProducao = linhasProducao

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.date)

        this.updateDate()
      },

      handleUpdateDadosSomatorio (somatorioAtual, somatorioAnterior, tituloGrafico, formatacaoDados) {
        this.tituloComparativoFatVolume = tituloGrafico

        this.montarGraficoSomatorio(somatorioAtual, somatorioAnterior, formatacaoDados)
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async updateDate () {
        eventEmit.$emit('update-datas-vendas', this.primeiroDia, this.date, this.select, this.supervisores, this.vendedores, this.areas, this.redes, this.receita, this.segmento, this.classificacoes, this.categoria, this.promotor, this.linhaProducao)

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.loadingFaturamento = true
        this.loadingFaturamentoAnoAnterior = true
        this.loadingFaturamento7MesesAnteriores = true
        this.loadingFaturamentoAcumuladoAnual = true

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        if (this.chartBarAcumuladoAnual.data) {
          this.chartBarAcumuladoAnual.destroy()
        }

        await Vendas.showFaturamentoVendas4(this.primeiroDia, this.date, this.select, this.supervisores, localStorage.tokencontrato, this.vendedores, this.areas, this.redes, this.classificacoes, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamento = this.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            } else if (resposta.data.text === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Vendas.showFaturamentoMesAnoAnterior4(this.primeiroDia, this.date, this.select, this.supervisores, localStorage.tokencontrato, this.vendedores, this.areas, this.redes, this.classificacoes, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoAnoAnterior = resposta.data.faturamentoMesAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamentoAnoAnterior = resposta.data.faturamentoMesAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            } else if (resposta.data.text === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingFaturamentoAnoAnterior = false })
      },

      montarGraficoSomatorio (somatorioAnoCorrente, somatorioAnoAnterior, formato) {
        try {
          if (this.chartBarAcumuladoAnual.data) {
            this.chartBarAcumuladoAnual.destroy()
          }

          const ctx = document.getElementById('myChart9').getContext('2d')

          if (formato) {
            this.chartBarAcumuladoAnual = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Ano Corrente'],
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: [somatorioAnoAnterior],
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Faturamento',
                    data: [somatorioAnoCorrente],
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    align: 'top',
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Ano Anterior'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else {
            this.chartBarAcumuladoAnual = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Ano Corrente'],
                datasets: [
                  {
                    label: 'VolumeAnoAnterior',
                    data: [somatorioAnoAnterior],
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Volume',
                    data: [somatorioAnoCorrente],
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    align: 'top',
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                  },
                },
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Ano Anterior'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          }
        } catch (error) {
          console.error('Erro ao montar o gráfico de somatório:', error)
          this.showSnackbar('error', 3000, 'Erro ao montar o gráfico de somatório')
        } finally {
          this.loadingFaturamentoAcumuladoAnual = false
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #vlrFaturamentoVenda {
      margin: -2rem 0 0 2.1rem;
    }

    #faturamentoVenda {
      font-size: 14px;
      margin: -1rem 0 0 3rem;
    }

    #faturamentoMesAnoAnteriorVenda {
      font-size: 14px;
      margin: -9.6rem 0 0 17rem;
    }

    #componentevlrFatMesAnteriorVenda {
      margin: -5.2rem 0 0 12.4rem;
    }

    #textoPrincipaisClientes {
      width: 100%;
      font-size: 12px;
    }

    #iconInformationAcumuladoAnual {
      margin: -6.5rem 0 0 28.5rem;
    }

    #dividerId {
      margin: -4rem 0 0 0;
    }

    #vendas7MesesAnterioresIdsVenda {
      margin: 0rem 0 0 3rem;
    }

    #iconInformationAcumuladoAnualComparativoVenda {
      margin: 0 0 0 -1.8rem;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #iconInformationAcumuladoAnual {
      margin: 0 0 0 5rem;
    }

    #faturamentoVenda {
      font-size: 14px;
      margin: 1rem 0 0 9rem;
    }

    #vlrFaturamentoVenda {
      margin: -2rem 0 0 7rem;
    }

    #faturamentoMesAnoAnteriorVenda {
      font-size: 14px;
      margin: 1rem 0 0 20rem;
    }

    #componentevlrFatMesAnteriorVenda {
      margin: -2rem 0 0 17rem
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoVenda {
      margin: 0 0 0 5rem !important;
    }

    #iconInformationAcumuladoAnual {
      margin: 0 0 0 10rem;
    }
  }

  @media screen
  and (min-width: 1601px) {
    #faturamentoVenda {
      margin: 0 0 0 5rem !important;
    }

    #iconInformationAcumuladoAnual {
      margin: 0 0 0 15rem;
    }

    #iconInformationAcumuladoAnualComparativoVenda {
      margin: 0 0 0 4rem;
    }
  }
</style>

<style lang="sass">
  #iconInformationAcumuladoAnual
    margin: 0 0 0 10rem

  #iconInformationAcumuladoAnualComparativoVenda
    margin: 0 0 0 1rem

  #faturamentoVenda
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 5rem
    font-weight: bold

  #vlrFaturamentoVenda
    margin: -2rem 0 0 4rem

  #faturamentoMesAnoAnteriorVenda
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 5rem
    font-weight: bold

  #componentevlrFatMesAnteriorVenda
    margin: -2rem 0 0 4rem

  #btnRefazerVendas
    margin: 1.5rem auto

  .textoAcumuladoAnual
    margin: 0 0 1rem 1rem

  #textoFaturamentoClienteProduto
    margin: 0 0 0.2rem 1rem

  #textoEvolucaoVenda
    margin: 0 0 0 1rem

  #legendaVendas
    font-size: 12px

  #listItemFaturamentoVendas
    // padding-right: 107rem !important
    margin: -2rem 0 0 -1rem

  #componenteFaturamento
    margin: -3rem 0 0 0

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #componenteFaturamentoAnual
    margin: -2rem 0 0 0

</style>
